<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-sales-hold',
    }"
  >
    <h4 class="mt-6 mb-9">
      Glad you're here, {{ firstName }}!
    </h4>
    <p class="p3 mb-6">
      {{ companyName || 'Your company' }}'s free trial has ended,
      but we're so happy your team liked using Datapeople. (We loved having you!)
      Not ready to say goodbye to all the progress you made? Get in touch at
      <a
        :href="`mailto:${accountExecutiveEmail || 'hello@datapeople.io'}?subject=Trial%20expired`"
      >
        {{ accountExecutiveEmail || 'hello@datapeople.io' }}.
      </a>
    </p>
    <p class="p3">
      We can't wait to reconnect!
    </p>
  </WizardContent>
</template>

<script>
import WizardContent from '@/components/shared/WizardContent.vue';
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'TrialExpired',
  components: {
    WizardContent,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName', 'companyName', 'accountExecutiveEmail']),
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Trial Expired' });
  },
};
</script>
